<template>
	<div class="pat3">
		<div class="main">
			<b>Participate process</b>
			<h1>参与流程</h1>
			<el-image :src="participatePath" fit="cover"></el-image>
		</div>
	</div>
</template>

<script>
	import {
		getProject
	} from '@/request/api.js';
	export default {
		name: 'pat3',
		props: {
			participatePath: String
		},
		data() {
			return {
				mainColor: ''
			}
		},
		created() {
			this.mainColor = localStorage.getItem('mainColor');
			this.getProjectFun();
		},
		mounted() {},
		methods: {
			// 首页项目介绍
			getProjectFun() {
				getProject().then(res => {
					if (res.code == 200) {
						// console.log()
						this.mainColor = res.data.mainColor;
					}
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	$main-color: v-bind(mainColor); // 注意这里的写法在某些构建工具中可能不支持，需要使用其他方法

	.pat3 {
		padding: 100px 0;

		.main {
			width: 1200px;
			margin: auto;
			display: flex;
			flex-direction: column;

			b {
				color: $main-color;
				font-size: 16px;
			}

			h1 {
				font-size: 70px;
				font-weight: 600;
				line-height: 1.5;
			}

			.el-image {
				width: 100%;
				// height: 650px;
				margin-top: 90px;
				// box-shadow: 0 0 10px rgba(102, 102, 102, .1);
			}
		}
	}
</style>